module.exports = __webpack_public_path__ + "img/go_server.c6a1e414.png";